import { Box, List, ListItem, ListItemIcon, styled, Typography } from "@mui/material";

import { Divider } from "@/Components/v2/atoms/Divider";
import SelectableCardV2 from "@/Components/v2/molecule/SelectableCard/SelectableCardV2";

export interface BulletPoint {
  text: React.ReactNode;
  icon: React.ReactNode;
}

const IconContainer = styled("div")({
  width: "48px",
  height: "48px",
  marginBottom: "8px",
  borderRadius: "50%",
  border: "1px solid",
  borderColor: "rgba(25, 118, 210, 0.12)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const HeaderContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  width: "100%",
  marginTop: "-4px",
  marginBottom: "4px",
});

interface ScenarioCardProps {
  onClick: () => void;
  title: string;
  description: string;
  bulletPoints: BulletPoint[];
  icon?: React.ReactNode;
  pill?: React.ReactNode;
  disabled?: boolean;
}

export const ScenarioCard: React.FC<ScenarioCardProps> = ({
  onClick,
  title,
  description,
  bulletPoints,
  icon,
  pill,
  disabled = false,
}) => {
  return (
    <SelectableCardV2 onClick={onClick} disabled={disabled}>
      <HeaderContainer>
        {icon && <IconContainer>{icon}</IconContainer>}
        {pill}
      </HeaderContainer>
      <Box sx={{ height: "80px", mb: 2 }}>
        <Typography variant="h6" fontWeight={600} mb={0.5}>
          {title}
        </Typography>
        <Typography variant="body2">{description}</Typography>
      </Box>
      <Divider sx={{ mb: 2, width: "100%" }} />
      <List>
        {bulletPoints.map((point, index) => (
          <ListItem
            key={index}
            sx={{
              padding: "4px 0",
              alignItems: "flex-start",
            }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>{point.icon}</ListItemIcon>
            <Typography variant="body2">{point.text}</Typography>
          </ListItem>
        ))}
      </List>
    </SelectableCardV2>
  );
};

export default ScenarioCard;
